"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equal = exports.isTruelyObject = void 0;
/* eslint-disable @typescript-eslint/no-use-before-define */
function isTruelyObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
exports.isTruelyObject = isTruelyObject;
function baseIsEqual(value, other) {
    if (value === other)
        return true;
    if (typeof value !== typeof other)
        return false;
    if (Number.isNaN(value) && Number.isNaN(other))
        return true;
    return false;
}
function objEqualShallow(value, other) {
    var valueProps = Object.getOwnPropertyNames(value);
    var otherProps = Object.getOwnPropertyNames(other);
    if (valueProps.length !== otherProps.length)
        return false;
    for (var i = 0, len = valueProps.length; i < len; i++) {
        var propName = valueProps[i];
        if (!baseIsEqual(value[propName], other[propName]))
            return false;
    }
    return true;
}
function arrayEqualShallow(value, other) {
    if (value.length !== other.length)
        return false;
    for (var i = 0, len = value.length; i < len; i++) {
        if (!baseIsEqual(value[i], other[i]))
            return false;
    }
    return true;
}
function isShallowEqual(value, other) {
    if (baseIsEqual(value, other))
        return true;
    if (isTruelyObject(value) && isTruelyObject(other))
        return objEqualShallow(value, other);
    if (Array.isArray(value) && Array.isArray(other))
        return arrayEqualShallow(value, other);
    return false;
}
function isDeepEqual(value, other) {
    if (baseIsEqual(value, other))
        return true;
    if (isTruelyObject(value) && isTruelyObject(other))
        return objEqualDeep(value, other);
    if (Array.isArray(value) && Array.isArray(other))
        return arrayEqualDeep(value, other);
    return false;
}
function arrayEqualDeep(value, other) {
    if (value.length !== other.length)
        return false;
    for (var i = 0, len = value.length; i < len; i++) {
        if (!isDeepEqual(value[i], other[i]))
            return false;
    }
    return true;
}
function objEqualDeep(value, other) {
    var valueProps = Object.getOwnPropertyNames(value);
    var otherProps = Object.getOwnPropertyNames(other);
    if (valueProps.length !== otherProps.length)
        return false;
    for (var i = 0, len = valueProps.length; i < len; i++) {
        var propName = valueProps[i];
        if (!isDeepEqual(value[propName], other[propName]))
            return false;
    }
    return true;
}
/**
 * 对象比较。
 * @param value 第一个比较的值。
 * @param other 第二个比较的值。
 * @param options 可选参数，可选项：`deep` 是否深比较。
 * @returns {boolean} 是否相等。
 */
function equal(value, other, opt) {
    if (opt === void 0) { opt = { deep: false }; }
    if (!opt.deep)
        return isShallowEqual(value, other);
    return isDeepEqual(value, other);
}
exports.equal = equal;
//# sourceMappingURL=equal.js.map